var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11273 2.93714L8 4L7.11273 5.06286L7.23636 6.46857L5.92364 6.78095L5.23636 7.99619L4 7.44L2.76364 8L2.07636 6.78476L0.763636 6.47238L0.887273 5.06286L0 4L0.887273 2.93333L0.763636 1.52381L2.07636 1.21524L2.76364 0L4 0.55619L5.23636 0L5.92364 1.21905L7.23636 1.53143L7.11273 2.93714ZM2.44294 3.80263L2.46695 3.78826L2.46182 3.78286L2.44294 3.80263Z",
    fill: "#65A8EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50003 4.69497L2.80503 3.99997L2.56836 4.23497L3.50003 5.16664L5.50003 3.16664L5.26503 2.93164L3.50003 4.69497Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.f71acf18b905e331347f48ed77d63135.svg";
export { ForwardRef as ReactComponent };